import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./HomeCard.css";
import { colors } from "@mui/material";
import Featured from "../Featured/Featured";
import { useTranslation } from "react-i18next";

const Dashboardcard = ({ progress }) => {

    const { t } = useTranslation('global');

    return (
        <div  style={{  borderRadius: 8,margin:15 }}>
            {/* <h3>Dashboard</h3> */}
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center',  }}>
                <Featured value={ parseFloat(progress?.totalProgress?.exercise?.percent).toFixed(0)} title={t('totalExercise')} />
                <Featured value={parseFloat(progress?.weekProgress?.exercise?.percent).toFixed(0)} title={t('weekExercise')} />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center',  }}>
                <Featured value={parseFloat(progress?.totalProgress?.education?.percent).toFixed(0)} title={t('totalEducation')} />
                <Featured value={parseFloat(progress?.weekProgress?.education?.percent).toFixed(0)} title={t('weekEducation')} />
            </div>
        </div>
    )
}

export default Dashboardcard;